import request from '@/shared/api/request';

export const deleteVolume = (uuid: string): Promise<void> =>
  request({
    url: `/volumes/${uuid}/`,
    method: 'DELETE',
  });
